import './hero-home.component.scss';
import {Swiper, Pagination, Navigation, EffectFade} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const heroHome = document.querySelector('.hero-home')

if (heroHome) {
  new Swiper('.hero-background.swiper', {
    modules: [Pagination, Navigation, EffectFade],
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.hero-home__pagination.swiper-pagination',
      clickable: true
    }
  })
}
